<template>
  <div class="animated fadeIn">
     <spinner v-if="loading"/>
     <b-card>
        <div slot="header">
           <strong>Search PO</strong>
        </div>
        <b-row>
            <b-col sm="2">
               <b-form-group>
                  <label for="po_num">PO No</label>
                  <b-form-input type="text" id="po_num" v-model="filter.po_num" @keyup.enter="searchPO" v-on:keyup.enter="$event.target.nextElementSibling.focus()"></b-form-input>
               </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group>
                   <label for="supplier_id">Supplier</label>
                   <supplierLookup v-bind:url="apiUrl" v-on:selected="setSupplierId($event)" :lookupId="filter.supplier_id"></supplierLookup>
                </b-form-group>
             </b-col>
             <b-col sm="2">
                <b-form-group>
                   <label for="date_start">Date Start</label>
                   <b-form-input type="date" id="date" v-model="filter.date_start"></b-form-input>
                </b-form-group>
             </b-col>
             <b-col sm="2">
                <b-form-group>
                   <label for="date_end">Date End</label>
                   <b-form-input type="date" id="date_end" v-model="filter.date_end"></b-form-input>
                </b-form-group>
             </b-col>
             <b-col sm="1">
                <b-form-group >
                    <label for="po_status">PO Status</label>
                    <b-form-select id="po_status" v-model="filter.po_status"
                      :plain="true"
                      :options="['','PENDING', 'APPROVED', 'CANCELLED']"
                      value="">
                    </b-form-select>
                  </b-form-group>
             </b-col>
             <b-col sm="2">
                <b-form-group >
                    <label for="fulfilment_status">Fulfilment Status</label>
                    <b-form-select id="fulfilment_status" v-model="filter.fulfilment_status"
                      :plain="true"
                      :options="['','PARTIAL', 'FULFILLED', 'MANUAL CLOSED','UNFULFILLED']"
                      value="">
                    </b-form-select>
                  </b-form-group>
             </b-col>
         </b-row>
        <div slot="footer">
           <b-button type="submit" size="lg" variant="primary" @click="searchPO"> Search</b-button>
           &nbsp;&nbsp;
           <b-button type="submit" size="lg" variant="success" @click="newPO">New Purchase Order</b-button>
        </div>
     </b-card>
        <b-row v-if="getRowCount(searchResults) > 0 && !loading">
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Search Results</strong>
                     </div>
                     <div class="table-responsive">
                        <b-table class="table-hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                          :per-page="perPage" @row-clicked = "rowClick" :items="searchResults">
                        </b-table>
                     </div>
                    <nav>
                        <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                    <div slot="footer">
                        <exportExcel
                          class   = "btn btn-primary btn-lg"
                          size ="lg"
                          :data   = "searchResults"
                          :fields = "exportHeaders"
                          name    = "po.xls">
                          Export to Excel
                      </exportExcel>
                      &nbsp;&nbsp;
                      <b-button type="button" size="lg" variant="success" @click="print">Print</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-else-if="noResults" >
            <b-col sm="12">
              <div align="center">
                <strong>No Purchase Order Found</strong>
              </div>                    
            </b-col>
        </b-row>
    </b-row>
  </div>


</template>
<script>
  import axios from 'axios'
  import {apiSupplierLookup, apiPoSearch,authHeader} from '@/functions/common.vue'
  import supplierLookup from '@/components/Autocomplete.vue'
  import spinner from '@/components/Spinner.vue'
  import exportExcel from 'vue-json-excel' 

  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
      "Roboto": {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-Italic.ttf'
        },
   };
  export default 
  {
    components: {supplierLookup, spinner,exportExcel},
    props: {
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data () {
    return {
      loading: false,
      filter: {
        po_num: '',
        supplier_id: '',
        date_start: '',
        date_end: '',
        po_status: '',
        fulfilment_status:''
      },
      apiUrl: apiSupplierLookup,
      supplierId: '',
      seen :false,
      searchResults: [],
      searchResultsFields: [
        {key: 'po_num', label: 'PO No'},
        {key: 'po_date' ,label: 'Date'},
        {key: 'supplier_name' ,label: 'Supplier'},
        {key: 'location_id', label:'Location Code'},
        {key: 'location_name' ,label: 'Location'},
        {key: 'author_shortname' ,label: 'Requestor'},
        {key: 'po_status' ,label: 'PO Status'},
        {key: 'po_status_date' ,label: 'Updated On'},
        {key: 'po_approver_user_shortname' ,label: 'Updated By'},
        {key: 'po_fulfilment_status' ,label: 'Fulfilment Status'},
        {key: 'po_fulfilment_date' ,label: 'Updated On'},
        {key: 'po_fulfilment_user_shortname' ,label: 'Updated By'}
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      noResults: false,
      exportHeaders:
        {
          'PO No': 'po_num',
          'Date': 'po_date',
          'Supplier': 'supplier_name',
          'Location Code': 'location_id',
          'Location': 'location_name',
          'Requestor':'author_shortname',
          'PO Status':'po_status',
          'PO Status Last Updated On':'po_status_date',
          'PO StatusUpdated By':'po_approver_user_shortname',
          'Fulfilment Status':'po_fulfilment_status',
          'Fulfilment Status Last Updated On':'po_fulfilment_date',
          'Fulfilment Status Updated By':'po_fulfilment_user_shortname'
        },
    }
    },
    created () 
    {
      const auth_header = localStorage.access_token;
      window.addEventListener('keyup', this.checkKey)
    },
    methods:
    {
      print()
        {
          var rows = []
          var row = []
          var date = new Date()
          rows.push(['PO No',
          'Date',
          'Supplier',
          'Location Code',
          'Location',
          'Requestor',
          'PO Status',
          'Last Updated On',
          'By',
          'Fulfilment Status',
          'Last Updated On',
          'By'
          ])

          for (let key in this.searchResults)
          {
            var data = this.searchResults[key]
            row = [data.po_num, data.po_date, data.supplier_name, data.location_id, data.location_name, data.author_shortname, data.po_status, data.po_status_date, data.po_approver_user_shortname, data.po_fulfilment_status, data.po_fulfilment_date, data.po_fulfilment_user_shortname]
            rows.push(row)
          }
          var dd = {
            header:{ text: 'Purchase Order List generated on'+ " "+ date, margin: [ 5, 10, 10, 20 ],alignment: 'center',fontSize:7 },
            pageSize: 'A4',
            pageOrientation: 'landscape',
            defaultStyle: {
            font: 'ukai',
          },
            // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
            pageMargins: [30, 20, 30, 20 ],

                    content: [
                      {
                          fontSize: 6,
                          layout: 'lightHorizontalLines', // optional
                          table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 1,
                            widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto','auto' ],

                            body: 
                              rows
                            
                          }
                        }
                      ]
          };

          pdfMake.createPdf(dd).open();
        },
        checkKey(e)
        {
          if (e.key == 'Enter')
          {
            //this.target.nextElementSibling.focus()
          }
        },
        searchPO()
        {
          this.loading = true
          this.submitted =true
          this.seen =true
          var sf =
          [
            "po_num LIKE " + this.filter.po_num
            ,"supplier_id = " + this.filter.supplier_id
            ,"po_date >= " + this.filter.date_start
            ,"po_date <= " + this.filter.date_end
            ,"po_status = " + this.filter.po_status
            ,"po_fulfilment_status = " + this.filter.fulfilment_status
          ]
          
            axios.post(apiPoSearch, sf,authHeader())
              .then (res => 
              {
                return res
                
              })
              .then (data =>
              {
                const resultArray = []
                const myData = data.data.data.list
                
                for (let key in myData)
                {
                  var date = myData[key].po_date
                  var date = new Date(date);
                  var poStatusDate = myData[key].po_status_date
                  var poApprover = myData[key].po_approver_user_shortname
                  var fulfilmentStatusDate = myData[key].po_fulfilment_date
                  var fulfilmentUserShortname = myData[key].po_fulfilment_user_shortname
                  var poStatusDateResult 
                  var fulfilmentStatusDateResult
                  var poApproverResult
                  if(poStatusDate == null)
                  {
                    poStatusDateResult = '-'
                  }
                  else
                  {
                    var psDate = new Date(poStatusDate)
                    poStatusDateResult  = "" + (psDate.getDate() > 9 ? '' : '0') + psDate.getDate() + '/'+  ((psDate.getMonth() + 1) > 9 ? '' : '0') + (psDate.getMonth() + 1) + '/' + psDate.getFullYear()+" " + (psDate.getHours() > 9 ? '' : '0') + psDate.getHours() + ":" + (psDate.getMinutes() > 9 ? '' : '0') + psDate.getMinutes() + ":" + (psDate.getSeconds() > 9 ? '' : '0') + psDate.getSeconds()
                  }
                 // console.log(poApprover)
                  if(poApprover == null)
                  {
                    poApproverResult = '-'
                  }
                  else
                  {
                    poApproverResult = poApprover
                  }
                  if(fulfilmentStatusDate  == null)
                  {
                    fulfilmentStatusDateResult = '-'
                  }
                  else
                  {
                    var fsDate = new Date(fulfilmentStatusDate)
                    fulfilmentStatusDateResult  = "" + (fsDate.getDate() > 9 ? '' : '0') + fsDate.getDate() + '/'+  ((fsDate.getMonth() + 1) > 9 ? '' : '0') + (fsDate.getMonth() + 1) + '/' + fsDate.getFullYear()+" " + (fsDate.getHours() > 9 ? '' : '0') + fsDate.getHours() + ":" + (fsDate.getMinutes() > 9 ? '' : '0') + fsDate.getMinutes() + ":" + (fsDate.getSeconds() > 9 ? '' : '0') + fsDate.getSeconds()
                  }

                  if (fulfilmentUserShortname == null)
                  {
                    fulfilmentUserShortname = '-'
                  }
                  var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                  myData[key].po_date=result
                  myData[key].po_status_date = poStatusDateResult
                  myData[key].po_approver_user_shortname = poApproverResult
                  myData[key].po_fulfilment_date = fulfilmentStatusDateResult
                  myData[key].po_fulfilment_user_shortname = fulfilmentUserShortname
                  resultArray.push(myData[key])
                  this.loading = false
                }
                this.searchResults = resultArray
                if(this.searchResults.length == 0)
                {
                  this.loading = false
                  this.noResults =true
                }
              })
              .catch(error => console.log(error))
        },
        setSupplierId(obj)
        {
          var id

          if (obj !== null)
            id = obj.id
          else
            id = ''

          this.filter.supplier_id = id
        },
        getRowCount (list) 
        {
          return list.length
        },
        rowClick(item, index)
        {
            this.$router.push({ name: 'Purchase Order (PO)', params: { poNum: item.po_num }})
        },
        newPO()
        {
          this.$router.push({ name: 'Purchase Order (PO)', params: { poNum: '_new' }})
        }
    },
  }
</script>
<style>
    .main {overflow-x: overlay;overflow-y: overlay;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/views/po/pos.vue